import React, { Fragment, useEffect, useState } from "react";
import Swal from "sweetalert2";

import { Row, Col, Card, Badge } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import DataTable from "react-data-table-component";
import Dropdown from "react-bootstrap/Dropdown";
import { GET, POST, PATCH } from "../../../services/AxiosService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { Collapse, Button } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { BsChevronRight } from "react-icons/bs";
const DaftarDonasi = () => {
  const [openFilter, setOpenFilter] = useState(false);
  const location = useLocation();
  const { tipe, start, end } = location.state || {};
  const navigate = useNavigate();
  const [data, setData] = useState();
  //server side
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [referenceNoSearch, setReferenceNoSearch] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState("");
  const [tipeDonatur, setTipeDonatur] = useState([]);
  const [selectedTipeDonatur, setSelectedTipeDonatur] = useState("");
  const [tipeDonasi, setTipeDonasi] = useState([]);
  const [selectedTipeDonasi, setSelectedTipeDonasi] = useState(tipe);
  const [selectedStatusDonasi, setSelectedStatusDonasi] = useState("");
  const [selectedNameStatusDonasi, setSelectedNameStatusDonasi] = useState("");
  const [selectedInfaqBuku, setSelectedInfaqBuku] = useState("");
  const [startDate, setStartDate] = useState(start);
  const [endDate, setEndDate] = useState(end);
  const [internalDateTo, setInternalDateTo] = useState(null);
  const [meta, setMeta] = useState("");
  const [buku, setBuku] = useState([]);
  const [bukuAll, setBukuAll] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [editingData, setEditingData] = useState(null);
  console.log(location.state?.periodName);
  console.log(location.state?.tipe);

  const [formData, setFormData] = useState({
    donaturName: "",
    attachmentLink: "",
    referenceNo: "",
    type_donation: "",
    paid_at: "",
    paymentMethod: "",
    status_name: "",
    // new
    cara_pembayaran: "",
    paket_buku: "",
    jumlah_paket_buku: "",
    paid_at: "",
    total_donasi: 0,
  });
  const [validated, setValidated] = useState(false);
  const fetchData = async (page, perPage, sortField, sortOrder, search, tipeDonasi, infaqBuku, tipeDonatur, statusDonasi, startDate, endDate, referenceNoSearch) => {
    const params = {
      page,
      size: perPage,
      sort: sortField,
      orderby: sortOrder,
      search,
      reference_no: referenceNoSearch, // <-- Add this
      type_donation: tipeDonasi,
      student_type_name: tipeDonatur,
      status: statusDonasi.length > 0 ? statusDonasi : "Dalam pengiriman,Pesanan Terkonfirmasi,Proses cetak,Sudah dimiliki,Menunggu Pembayaran",
      start_date: startDate,
      end_date: internalDateTo,
      infaqBuku,
    };
    const res = await GET(`/donation`, params);
    setData(res?.data);
    setTotalRows(res?.meta?.amount);
    setMeta(res?.meta);
  };

  const fetchServerData = () => {
    fetchData(currentPage, perPage, sortField, sortOrder, searchTerm, selectedTipeDonasi, selectedInfaqBuku, selectedTipeDonatur, selectedStatusDonasi, startDate, endDate, referenceNoSearch);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerPageChange = (newPerPage) => {
    setPerPage(newPerPage);
    setResetPaginationToggle(!resetPaginationToggle);
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    localStorage.setItem("searchTerm", value);
    setCurrentPage(1); // Reset to first page
    setResetPaginationToggle(prev => !prev); // Reset pagination

    fetchData(
      1, // <- Reset to first page
      perPage,
      sortField,
      sortOrder,
      value, // <-- updated search term
      selectedTipeDonasi,
      selectedInfaqBuku,
      selectedTipeDonatur,
      selectedStatusDonasi,
      startDate,
      endDate,
      referenceNoSearch
    );
  };


  const handleSort = (column, direction) => {
    setSortField(column.field);
    setSortOrder(direction);
  };

  useEffect(() => {
    fetchServerData();
    fetchPaymentMethods();
    fetchDataBukuAll(); // call it here
  }, [perPage, searchTerm, currentPage, sortField, sortOrder, selectedTipeDonasi, selectedInfaqBuku, selectedTipeDonatur, selectedStatusDonasi, startDate, endDate, referenceNoSearch]);

  function currencyFormat(num) {
    num = parseFloat(num);
    return num
      .toFixed(2)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      .replace(/\.00$/, "");
  }

  const getCurrentDatetimeLocal = () => {
    const now = new Date();
    const pad = (n) => n.toString().padStart(2, '0');
    return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}T${pad(now.getHours())}:${pad(now.getMinutes())}`;
  };

  const fetchTipeDonasi = async () => {
    const res = await GET(`master-data/type?type=Tipe Donasi`);
    setTipeDonasi(res?.data);
  };
  const fetchDataBuku = async () => {
    const res = await GET(`book?status=1`);
    let data = [];
    data.push({
      id: 1,
      name: "Infaq",
    });
    data.push(...res?.data);
    setBuku(data);
  };
  const fetchTipeDonatur = async () => {
    const res = await GET(`master-data/type?type=Tipe Pelajar`);
    setTipeDonatur(res?.data);
  };

  useEffect(() => {
    fetchTipeDonasi();
    fetchDataBuku();
    fetchTipeDonatur();
  }, []);

  useEffect(() => {
    if (tipeDonasi.length > 0 && location.state?.tipe) {
      setSelectedTipeDonasi(location.state.tipe);
    }
  }, [tipeDonasi, location.state?.tipe]);

  // paid at default
  useEffect(() => {
    if (!editingData) {
      setFormData((prev) => ({
        ...prev,
        paid_at: formatToDatetimeLocal(new Date()),
      }));
    }
  }, [editingData]);

  const columns = [
    {
      name: "Nama Donatur",
      selector: (row) => row.user_name,
      sortable: true,
      field: "user_name",
    },
    {
      name: "Tipe Donasi",
      selector: (row) => row.type_donation,
      sortable: true,
      field: "type_donation",

    },
    {
      name: "ID",
      selector: (row) => row.no,
      sortable: true,
      field: "no",
      cell: row => (
        <span
          style={{
            maxWidth: '100px',
            wordBreak: 'break-word',
            whiteSpace: 'normal',
          }}
        >
          {row.no}
        </span>
      ),
    },
    {
      name: "Tipe Infaq/Buku",
      selector: (row) => row.book_name,
      sortable: true,
      field: "book_name",
    },
    {
      name: "Qty",
      selector: (row) => row.book_qty,
      sortable: true,
      field: "book_qty",
      cell: (row) => (
        <span style={{ textAlign: "center", width: "30%" }}>
          {row.book_qty}
        </span>
      ),
      // center:true
    },
    {
      name: "Tipe Donatur",
      selector: (row) => row.student_type_name,
      sortable: true,
      field: "student_type_name",
    },
    {
      name: "No Refrensi",
      selector: (row) => row.reference_no,
      sortable: true,
      field: "reference_no",
      cell: row => (
        <span
          style={{
            wordBreak: 'break-word',
            whiteSpace: 'normal',
          }}
        >
          {row.reference_no}
        </span>
      ),
    },
    {
      name: "Total Donasi",
      selector: (row) => row.amount,
      sortable: true,
      field: "amount",
      cell: (row) => <span style={{ textAlign: "right", display: "block" }}>{currencyFormat(row.amount)}</span>,
      right: true, // aligns the column to the right
    },
    {
      name: "Waktu Donasi",
      field: "paid_at", // ✅ so server knows the column name
      sortable: true,
      selector: (row) => row.paid_at ? new Date(row.paid_at) : null, // sorting uses Date object
      cell: (row) => {
        if (!row.paid_at) return "-";
        const tanggal = new Date(row.paid_at);
        const formatTanggal = tanggal.toLocaleDateString("id-ID", {
          day: "2-digit",
          month: "long",
          year: "numeric",
        });
        const formatWaktu = tanggal.toLocaleTimeString("id-ID", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        });
        return `${formatTanggal} ${formatWaktu}`;
      }
    },
    // {
    //   name: "Status Donasi",
    //   selector: (row) => (row?.order?.status_name ? row?.order?.status_name : "-"),
    // },
    {
      name: "Status Donasi",
      selector: (row) => (row?.order?.status_name ? row?.order?.status_name : "-"),
      width: "210px",
      cell: (row) => {
        let displayText;
        if (row?.order?.status_name === "Menunggu Pembayaran") {
          displayText = (
            <Badge as="a" variant="outline-info badge-rounded">
              Menunggu Pembayaran
            </Badge>
          );
        } else if (row?.order?.status_name === "Pesanan Terkonfirmasi") {
          displayText = (
            <Badge as="a" variant="outline-success badge-rounded" style={{ outline: "yellow" }}>
              Sudah Dibayar
            </Badge>
          );
        } else if (row?.order?.status_name === "Kedaluarsa") {
          displayText = (
            <Badge as="a" variant="outline-danger badge-rounded">
              Kedaluarsa
            </Badge>
          );
        }
        return displayText;
      },
    },
    {
      name: "Aksi",
      selector: (row) => row.id,
      width: "200px", // Adjusted width for both buttons
      cell: (row) => (
        <div className="d-flex">
          <button
            className="btn btn-info shadow btn-xs sharp mx-1"
            title="Detail"
            onClick={() => {
              const flag = (row.attachment_link && row.reference_no) ? "Detail-Web" : "Detail";
              navigate(`/${row.id}/form-donasi/${flag}`, { state: { from: flag } });
            }}
          >
            <i className="fa fa-eye"></i>
          </button>

          {row.attachment_link && (
            <a
              href={row.attachment_link}
              className="btn btn-primary shadow btn-xs sharp mx-1"
              title="Lampiran"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa fa-link"></i>
            </a>
          )}

          {row.reference_no && (
            <button
              className="btn btn-success shadow btn-xs sharp mx-1"
              title="Edit"
              onClick={() => handleEditClick(row.id)}
            >
              <i className="fa fa-edit"></i>
            </button>

          )}
        </div>
      ),
    },
  ];
  const customStyles = {
    headRow: {
      style: {
        backgroundColor: "#FCFCFD",
        fontSize: "14px",
        fontWeight: "bold",
        color: "black",
      },
    },
    rows: {
      style: {
        backgroundColor: "#FFFFFF",
        "&:nth-child(2n)": {
          backgroundColor: "#F3F0FD",
        },
      },
    },
    cells: {
      style: {
        alignItems: "flex-start", // This will align content to the top
        paddingTop: "8px",
        paddingBottom: "8px",
        wordBreak: "normal",


      },
    },
  };

  const handleSelectTipeDonasi = (e) => {
    const value = e.target.getAttribute("value");
    setSelectedTipeDonasi(value);
  };


  const handleSelectTipeDonatur = (e) => {
    setSelectedTipeDonatur(e.target.getAttribute("value"));
  };

  // const handleSelectInfaqBuku = (e) => {
  //   setSelectedInfaqBuku(e.target.getAttribute("value"));
  // };

  const handleSelectInfaqBuku = (selectedOption) => {
    setSelectedInfaqBuku(selectedOption?.value || "");
  };

  const bukuOptions = Array.isArray(buku)
    ? buku.map((infaqBuku) => ({
      value: infaqBuku.name,
      label: infaqBuku.name,
    }))
    : [];

  const handleSelectStatusDonasi = (e) => {
    setSelectedStatusDonasi(e.target.getAttribute("value"));
    setSelectedNameStatusDonasi(e.target.textContent);
  };

  const handleDateFromChange = (date) => {
    const formattedDate = date?.toLocaleDateString("en-CA");
    setStartDate(formattedDate);
    setEndDate(null);
    setInternalDateTo(null);

    // ✅ Reset pagination and refetch
    setCurrentPage(1);
    setResetPaginationToggle(prev => !prev);
  };

  const handleDateToChange = (date) => {
    const formattedDate = date?.toLocaleDateString("en-CA");
    setEndDate(formattedDate);

    if (date) {
      const nextDay = new Date(date);
      nextDay.setDate(nextDay.getDate() + 1);
      const formattedNextDay = nextDay.toLocaleDateString("en-CA");
      setInternalDateTo(formattedNextDay);
    } else {
      setInternalDateTo(null);
    }

    // ✅ Reset pagination and refetch
    setCurrentPage(1);
    setResetPaginationToggle(prev => !prev);
  };

  const DatePickerWithClearIcon = ({ value, onChange, placeholderText }) => {
    return (
      <div
        className="datepicker-wrapper"
        style={{ position: "relative", display: "inline-block", paddingRight: "10px" }}
      >
        <DatePicker
          className="form-control datepicker-custom"
          value={value || ""}
          onChange={onChange}
          dateFormat="yyyy-MM-dd"
          placeholderText={placeholderText}
        />
        {value && (
          <i
            className="fa fa-times"
            onClick={() => onChange(null)}
            style={{
              position: "absolute",
              right: "20px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "#aaa",
            }}
          />
        )}
      </div>
    );
  };



  const parsePeriodNameToDates = (periodName) => {
    if (!periodName) return {};

    // Normalize spacing and remove extra characters
    let cleaned = periodName.trim().replace(/\s*-\s*/, "-"); // e.g., "Juli - Desember 2025" → "Juli-Desember 2025"

    // Fix cases like: "Juli - Desember 2025" where split(" ") gives > 2 parts
    const parts = cleaned.split(" ");
    if (parts.length > 2) {
      const yearStr = parts.pop(); // last part is year
      const rangePart = parts.join(" ");
      cleaned = `${rangePart} ${yearStr}`;
    }

    const [rangePart, yearStr] = cleaned.split(" ");
    if (!rangePart || !yearStr) return {};

    const [startAbbr, endAbbr] = rangePart.split("-");
    const year = parseInt(yearStr);
    if (!startAbbr || !endAbbr || isNaN(year)) return {};

    // Normalize input to capitalize first letter
    const normalize = (str) =>
      str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

    const abbrToIndex = {
      // English
      Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
      Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11,

      // Indonesian
      Januari: 0, Februari: 1, Maret: 2, April: 3, Mei: 4, Juni: 5,
      Juli: 6, Agustus: 7, September: 8, Oktober: 9, November: 10, Desember: 11,
      Agu: 7, Okt: 9, Des: 11,
    };

    const startMonth = abbrToIndex[normalize(startAbbr)];
    const endMonth = abbrToIndex[normalize(endAbbr)];

    if (startMonth == null || endMonth == null) return {};

    const start = new Date(year, startMonth, 1);
    const end = new Date(year, endMonth + 1, 0); // Last day of end month
    const internalEnd = new Date(end);
    internalEnd.setDate(internalEnd.getDate() + 1); // for inclusive range filtering

    return {
      startDate: start.toLocaleDateString("en-CA"),
      endDate: end.toLocaleDateString("en-CA"),
      internalDateTo: internalEnd.toLocaleDateString("en-CA"),
    };
  };





  useEffect(() => {
    const periodName = location.state?.periodName;
    if (periodName) {
      const { startDate, endDate, internalDateTo } = parsePeriodNameToDates(periodName);
      if (startDate && endDate && internalDateTo) {
        setStartDate(startDate);
        setEndDate(endDate);
        setInternalDateTo(internalDateTo);
      }
    }
  }, [location.state?.periodName]);

  const fetchPaymentMethods = async () => {
    try {
      const res = await GET("/payment-method");
      if (res && Array.isArray(res.data)) {
        setPaymentMethods(res.data); // <-- Important: set the array inside 'data'
      } else {
        console.error("Invalid response for payment methods:", res);
        setPaymentMethods([]);
      }
    } catch (error) {
      console.error("Failed to fetch payment methods:", error);
      setPaymentMethods([]);
    }
  };

  const fetchDataBukuAll = async () => {
    const res = await GET(`book-package`);
    setBukuAll(res?.data);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    const newFormData = {
      ...formData,
      [name]: value,
    };
    const total_donasi = hitungTotalDonasi(newFormData.paket_buku, newFormData.jumlah_paket_buku);

    setFormData({
      ...newFormData,
      total_donasi,
    });

    // setFormData((prevData) => ({
    //   ...prevData,
    //   [name]: value,
    // }));

    // setTouched(true);

    const form = e.currentTarget.form;
    const isValid = form.checkValidity();

    setValidated(isValid);

    if (isValid) {
      form.classList.remove("was-validated");
    } else {
      form.classList.add("was-validated");
    }
  };

  // const dataPaketBuku = [
  //   { id: 1, nama: "Paket A", harga: 150000 },
  //   { id: 2, nama: "Paket B", harga: 200000 },
  //   { id: 3, nama: "Paket C", harga: 175000 },
  // ];

  const hitungTotalDonasi = (paketId, jumlah) => {
    const selectedPaket = bukuAll.find((paket) => paket.id.toString() === paketId);
    if (!selectedPaket || !jumlah) return "0";

    const total = selectedPaket.price * parseInt(jumlah);
    return total;
  };



  const handleSubmit = async (e) => {
    e.preventDefault();

    const requestBody = {
      donatur_name: formData.user_name,
      payment_method_id: formData.cara_pembayaran,
      amount_infaq: Number(formData.total_donasi),
      attachment_link: formData.attachmentLink,
      reference_no: formData.referenceNo,
      paid_at: formData.paid_at, // <-- add this line
    };

    if (formData.type_donation === "2") {
      requestBody.bookPackage = [
        {
          bookPackageId: formData.paket_buku,
          book_qty: formData.jumlah_paket_buku,
        },
      ];
    }

    Swal.fire({
      title: "Loading...",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      let res;
      if (editingData) {
        // Edit Mode: Use PUT or PATCH with donation_id
        res = await PATCH(`/donation/update-web-donation/${editingData.donation_id}`, requestBody);
      } else {
        // Create Mode: Use POST
        res = await POST(`/donation/post-web-donation`, requestBody);
      }

      if (res) {
        Swal.fire({
          icon: "success",
          title: editingData ? "Berhasil mengedit donasi!" : "Berhasil membuat donasi baru!",
        }).then(() => {
          Swal.close();
          // Reset form
          setFormData({
            user_name: "",
            student_type_name: "",
            type_donation: "",
            cara_pembayaran: "",
            total_donasi: 0,
            paket_buku: "",
            jumlah_paket_buku: 0,
            referenceNo: "",
            attachmentLink: "",
            paid_at: getCurrentDatetimeLocal(), // ✅ auto-fill current time again
          });
          setEditingData(null); // Reset edit mode
          fetchServerData()
        });
      }
    } catch (error) {
      console.error("Submit error:", error);
      Swal.fire("Error", "Terjadi kesalahan saat menyimpan data.", "error");
    }
  };


  const handleEditClick = async (id) => {
    if (bukuAll.length === 0) {
      await fetchDataBukuAll(); // Make sure dropdown options are loaded
    }
    await fetchDataEdit(id);    // Then set form data correctly
  };
  function formatToDatetimeLocal(date) {
    if (!date) return "";
    const d = new Date(date);
    const pad = (n) => n.toString().padStart(2, "0");

    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }



  const fetchDataEdit = async (id) => {
    const res = await GET(`donation/get-web-donation${id}`);
    const data = res?.data;
    const detail = data?.detail_donation || {};


    setFormData((prev) => ({
      ...prev,
      user_name: data.user_name || "",
      attachmentLink: data.attachment_link || "",
      referenceNo: data.reference_no || "",
      type_donation: "2", // force show paket buku fields
      cara_pembayaran: data.payment_method_id || "",
      paket_buku: data.book_package_id || "",        // <-- set paket_buku here
      jumlah_paket_buku: detail.book_qty || 0,
      total_donasi: Number(data.amount) || 0,
      paid_at: formatToDatetimeLocal(data.paid_at) || "",
      status_name: data?.order?.status_name || "",
    }));

    setEditingData({
      ...data,
      detail_donation: Array.isArray(detail) ? detail : [detail],
    });

    setOpenFilter(true);
  };


  const handleReset = () => {
    setFormData({
      user_name: "",
      attachmentLink: "",
      referenceNo: "",
      type_donation: "",
      paid_at: "",
      paymentMethod: "",
      status_name: "",
      cara_pembayaran: "",
      paket_buku: "",
      jumlah_paket_buku: "",
      total_donasi: 0,
      type_donation: "",
      paid_at: getCurrentDatetimeLocal(),
    });
    setEditingData(null);
    setValidated(false);
  };

  const handleReferenceNoSearchChange = (e) => {
    const newRef = e.target.value;
    setReferenceNoSearch(newRef);
    setCurrentPage(1); // Reset to first page
    setResetPaginationToggle(prev => !prev); // Reset pagination

    fetchData(
      1, // <- Reset to first page
      perPage,
      sortField,
      sortOrder,
      searchTerm,
      selectedTipeDonasi,
      selectedInfaqBuku,
      selectedTipeDonatur,
      selectedStatusDonasi,
      startDate,
      endDate,
      newRef // ✅ updated reference
    );
  };

  useEffect(() => {
    setCurrentPage(1); // Go back to first page
    setResetPaginationToggle(prev => !prev); // Trigger DataTable to reset pagination
  }, [
    selectedTipeDonasi,
    selectedTipeDonatur,
    selectedInfaqBuku,
    selectedStatusDonasi,
    startDate,
    endDate,
  ]);
  return (
    <Fragment>
      <Row>
        <Col lg={12}>
          <Card>
            <Card.Header>
              <Card.Title>Daftar Donasi</Card.Title>
            </Card.Header>
            <div className="d-flex flex-column flex-md-row justify-content-between mt-4">
              <div className="d-flex flex-wrap px-4">
                <Dropdown className="mr-2 my-1">
                  <Dropdown.Toggle
                    style={{
                      background: "transparent",
                      borderColor: "grey",
                      color: "grey",
                    }}
                    id="dropdown-basic"
                  >
                    {selectedTipeDonasi || "Semua Tipe Donasi"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item key="all" value="" onClick={handleSelectTipeDonasi}>
                      Semua Tipe Donasi
                    </Dropdown.Item>
                    {Array.isArray(tipeDonasi) &&
                      tipeDonasi.map((donasiTipe) => (
                        <Dropdown.Item key={donasiTipe.id} value={donasiTipe.name} onClick={handleSelectTipeDonasi}>
                          {donasiTipe.name}
                        </Dropdown.Item>
                      ))}
                  </Dropdown.Menu>
                </Dropdown>

                <Dropdown className="mr-2  my-1">
                  <Dropdown.Toggle
                    style={{
                      background: "transparent",
                      borderColor: "grey",
                      color: "grey",
                    }}
                    id="dropdown-basic">
                    {selectedInfaqBuku
                      ? bukuOptions.find((b) => b.value === selectedInfaqBuku)?.label
                      : "Semua Infaq/Buku"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item
                      key="all"
                      onClick={() => handleSelectInfaqBuku({ value: "" })}
                    >
                      Semua Infaq/Buku
                    </Dropdown.Item>

                    {bukuOptions.map((option) => (
                      <Dropdown.Item
                        key={option.value}
                        onClick={() => handleSelectInfaqBuku({ value: option.value })}
                      >
                        {option.label}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>

                <Dropdown className="mr-2 my-1">
                  <Dropdown.Toggle
                    style={{
                      background: "transparent",
                      borderColor: "grey",
                      color: "grey",
                    }}
                    id="dropdown-basic"
                  >
                    {selectedTipeDonatur?.length > 0 ? selectedTipeDonatur : "Semua Tipe Donatur"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item key="all" value="" onClick={handleSelectTipeDonatur}>
                      Semua Tipe Donatur
                    </Dropdown.Item>
                    {Array.isArray(tipeDonatur) &&
                      tipeDonatur.map((donaturTipe) => (
                        <Dropdown.Item key={donaturTipe.id} value={donaturTipe.name} onClick={handleSelectTipeDonatur}>
                          {donaturTipe.name}
                        </Dropdown.Item>
                      ))}
                  </Dropdown.Menu>
                </Dropdown>

                <Dropdown className="mr-2  my-1">
                  <Dropdown.Toggle
                    style={{
                      background: "transparent",
                      borderColor: "grey",
                      color: "grey",
                    }}
                    id="dropdown-basic"
                  >
                    {selectedNameStatusDonasi?.length > 0 ? selectedNameStatusDonasi : "Tanpa Kedaluwarsa"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item key="semua_selain_kedaluarsa" value="Dalam pengiriman,Pesanan Terkonfirmasi,Proses cetak,Sudah dimiliki,Menunggu Pembayaran" onClick={handleSelectStatusDonasi}>
                      Tanpa Kedaluwarsa
                    </Dropdown.Item>
                    <Dropdown.Item key="menunggu_pembayaran" value="Menunggu Pembayaran" onClick={handleSelectStatusDonasi}>
                      Menunggu Pembayaran
                    </Dropdown.Item>
                    <Dropdown.Item key="pesanan_terkonfirmasi" value="Pesanan Terkonfirmasi" onClick={handleSelectStatusDonasi}>
                      Sudah Dibayar
                    </Dropdown.Item>
                    <Dropdown.Item key="kedaluarsa" value="Kedaluarsa" onClick={handleSelectStatusDonasi}>
                      Kedaluarsa
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                <div className="d-flex">
                  <div className="d-flex my-1">
                    <DatePickerWithClearIcon value={startDate} onChange={handleDateFromChange} placeholderText="Waktu Donasi (from)" />
                    <DatePickerWithClearIcon value={endDate} onChange={handleDateToChange} placeholderText="Waktu Donasi (to)" />
                  </div>
                </div>
              </div>
              <div className="d-flex flex-column align-self-baseline px-4">
                {/* Search Donasi */}
                <div className="input-group search-area mb-1">
                  <input
                    type="text"
                    className="form-control "
                    placeholder="Cari Donasi"
                    value={searchTerm}
                    onChange={handleSearchChange}
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">
                      <Link to="#">
                        <i className="flaticon-381-search-2" />
                      </Link>
                    </span>
                  </div>
                </div>

                {/* Search No. Ref */}
                <div className="input-group search-area mb-1">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Cari No. Ref"
                    value={referenceNoSearch}
                    onChange={handleReferenceNoSearchChange}
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">
                      <i className="flaticon-381-search-2" />
                    </span>
                  </div>
                </div>
              </div>

            </div>

            <div className="px-4 mt-2">
              <Button
                onClick={() => setOpenFilter(!openFilter)}
                aria-controls="collapse-filters"
                aria-expanded={openFilter}
                className="btn btn-primary d-flex align-items-center justify-content-between"
                style={{

                  borderRadius: "10px", // rounded edges
                  border: "none",
                  padding: "10px 20px",
                }}
              >
                <span>Tambah Donasi Dari Luar Aplikasi&nbsp;</span>
                <BsChevronRight
                  style={{
                    transform: openFilter ? "rotate(90deg)" : "none",
                    fontSize: "1rem",
                    transition: "transform 0.2s ease",
                  }}
                />
              </Button>
            </div>
            <Collapse in={openFilter}>
              <div className="mt-3 mx-5">
                <div
                  id="collapse-filters"
                  style={{
                    backgroundColor: "#084B5D",
                    borderRadius: "12px",
                    padding: "20px",
                    border: "1px solid"
                  }}
                >
                  <div className="card-body p-3 text-white">
                    <form className="form-valide" onSubmit={handleSubmit}>
                      <div className="row g-3">
                        {/* Row 1 */}
                        <div className="col-md-4 mt-1">
                          <label className="fw-semibold">Nama Donatur</label>
                          <input
                            className="form-control same-height-input "
                            type="text"
                            value={formData.user_name}
                            onChange={(e) =>
                              setFormData({ ...formData, user_name: e.target.value })
                            }
                            required
                          />
                        </div>

                        <div className="col-md-4 mt-1">
                          <label className="fw-semibold">Tipe Donasi</label>
                          <select
                            className="form-control same-height-input"
                            name="type_donation"
                            value={formData.type_donation}
                            onChange={handleChange}
                            required
                          >
                            <option value="">Pilih tipe donasi</option>
                            <option value="2">Donasi Buku</option>
                          </select>
                        </div>

                        {formData.type_donation == "2" && (
                          <>
                            <div className="col-md-4 mt-1">
                              <label className="fw-semibold">Paket Buku</label>
                              <select
                                className="form-control same-height-input"
                                name="paket_buku"
                                value={formData.paket_buku}
                                onChange={handleChange}
                                required
                              >
                                <option value="">Pilih paket buku</option>
                                {bukuAll.map((paket) => (
                                  <option key={paket.id} value={paket.id}>
                                    {paket.name}
                                  </option>
                                ))}
                              </select>
                            </div>

                            {/* Row 2 */}
                            <div className="col-md-4 mt-1">
                              <label className="fw-semibold">Jumlah Paket Buku</label>
                              <input
                                className="form-control same-height-input"
                                type="number"
                                name="jumlah_paket_buku"
                                onChange={handleChange}
                                value={formData.jumlah_paket_buku}
                                required
                              />
                            </div>

                            <div className="col-md-4 mt-1">
                              <label className="fw-semibold">Cara Pembayaran</label>
                              <select
                                className="form-control same-height-input"
                                name="cara_pembayaran"
                                value={formData.cara_pembayaran}
                                onChange={handleChange}
                                required
                              >
                                <option value="">Pilih cara pembayaran</option>
                                {paymentMethods.map((method) => (
                                  <option key={method.id} value={method.id}>
                                    {method.description}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div className="col-md-4 mt-1">
                              <label className="fw-semibold">Total Donasi</label>
                              <input
                                className="form-control form-control-sm bg-secondary-subtle text-dark same-height-input"
                                style={{ borderRadius: "6px" }}
                                value={`Rp ${formData.total_donasi.toLocaleString("id-ID")}` || 0}
                                disabled
                              />
                            </div>

                            {/* Row 3 */}
                            <div className="col-md-4 mt-1">
                              <label className="fw-semibold">Nomor Referensi</label>
                              <input
                                className="form-control form-control-sm same-height-input"
                                style={{ backgroundColor: "#fff", borderRadius: "6px" }}
                                type="text"
                                name="referenceNo"
                                value={formData.referenceNo}
                                onChange={handleChange}
                                required
                              />
                            </div>

                            <div className="col-md-4 mt-1">
                              <label className="fw-semibold">Link Lampiran</label>
                              <input
                                className="form-control form-control-sm same-height-input"
                                style={{ backgroundColor: "#fff", borderRadius: "6px" }}
                                type="text"
                                name="attachmentLink"
                                value={formData.attachmentLink}
                                onChange={handleChange}
                              />
                            </div>

                            <div className="col-md-4 mt-1">
                              <div className="form-group d-flex flex-column">
                                <label className="form-label fw-semibold ">
                                  Waktu Pembayaran
                                </label>
                                <DatePicker
                                  selected={
                                    formData.paid_at ? new Date(formData.paid_at) : null
                                  }
                                  onChange={(date) =>
                                    setFormData({ ...formData, paid_at: date })
                                  }
                                  showTimeSelect
                                  timeIntervals={15}
                                  dateFormat="yyyy-MM-dd HH:mm"
                                  className="form-control form-control-sm same-height-input"
                                  style={{ backgroundColor: "#fff", borderRadius: "6px" }}
                                  placeholderText="Pilih waktu pembayaran"
                                />
                              </div>
                            </div>
                          </>
                        )}
                      </div>

                      <div className="mt-3 d-flex gap-2">
                        <button
                          type="button"
                          className="btn btn-danger w-50 mx-2"
                          style={{
                            borderRadius: "6px",
                            border: "none",
                            height: "40%",
                          }}
                          onClick={handleReset}
                        >
                          Reset
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary btn-donasi w-50  mx-2"
                          style={{
                            borderRadius: "6px",
                            border: "none",
                            height: "40%",
                          }}
                        >
                          Simpan Perubahan
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </Collapse>


            <Card.Body>
              <p style={{ margin: "1px 0", fontWeight: "700" }}>
                Qty : {meta?.qty_total != null ? new Intl.NumberFormat("id-ID").format(meta.qty_total) : 0}
              </p>
              <p style={{ margin: "1px 0", fontWeight: "700" }}>Biaya : {meta?.amount_total != null ? new Intl.NumberFormat("id-ID").format(meta.amount_total) : 0}</p>
              {data && data.length > 0 ? (
                <DataTable
                  columns={columns}
                  data={data}
                  customStyles={customStyles}
                  pagination
                  paginationServer
                  sortServer
                  paginationRowsPerPageOptions={[10, 50, 100, 500]}
                  paginationResetDefaultPage={resetPaginationToggle}
                  paginationPerPage={perPage}
                  paginationTotalRows={totalRows}
                  onChangePage={handlePageChange}
                  onChangeRowsPerPage={handlePerPageChange}
                  onSort={handleSort}
                />
              ) : (
                <p>Tidak ada data</p>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};

export default DaftarDonasi;
